import { services } from "@/mocks/homeData";

export default function ServicesSection() {
  return (
    <section id="prestations" className="py-16 md:py-24 bg-background-950">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12 md:mb-16">
          <span className="text-sm font-semibold tracking-wider text-primary-500 uppercase mb-2 block">
            Ce que nous proposons
          </span>
          <h2 className="text-2xl md:text-4xl font-bold text-background-50 mb-4 font-heading tracking-wide">
            Nos prestations automobiles
          </h2>
          <p className="text-background-300 max-w-2xl mx-auto text-base md:text-lg">
            Garage automobile au Tampon, Mobicar Pro intervient sur l'ensemble
            des besoins d'entretien, de diagnostic et de réparation automobile
            de votre véhicule.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4 md:gap-6">
          {services.map((service) => (
            <div
              key={service.id}
              className="group relative bg-white border border-background-200 rounded-lg p-5 md:p-6 hover:border-primary-300 transition-all duration-300"
            >
              <div className="w-12 h-12 flex items-center justify-center rounded-md bg-primary-50 text-primary-500 mb-4 group-hover:bg-primary-500 group-hover:text-white transition-colors">
                <i className={`${service.icon} w-6 h-6 flex items-center justify-center text-xl`} />
              </div>
              <h3 className="text-lg font-semibold text-background-50 mb-2 font-heading tracking-wide">
                {service.title}
              </h3>
              <p className="text-sm text-background-300 leading-relaxed">
                {service.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}